import { useNavigate } from "react-router-dom";

export default function CosmeticCard({ item, nameColor }) {
  const navigate = useNavigate();

  if (!item) return null;

  const rarityImages = {
    common: "unicode-common",
    rare: "unicode-rare",
    limited: "unicode-limited",
    epic: "unicode-epic",
    legendary: "unicode-legendary",
    exotic: "unicode-exotic",
    partner: "unicode-partner",
  };

  return (
    <a
      className="oreuidiv"
      href={`/cosmetic/${item.type}/${item.id}`}
      onClick={(e) => {
        e.preventDefault();
        navigate(`/cosmetic/${item.type}/${item.id}`);
      }}
    >
      <div className="innershadoworeui">
        <div className={"oreuiimage " + (item.rarity || "common")}>
          {(item.type === "artifact" ||
            item.type === "cape" ||
            item.type === "mount") && (
            <img
              src={item.preview}
              width="302"
              height="298"
              alt=""
              loading="lazy"
              className="oreuiimages drop-shadow"
            />
          )}
          {(item.type === "projectile" || item.type === "killphrase") && (
            <h4
              style={{
                display: "flex",
                textAlign: "center",
                justifyContent: "center",
                alignItems: "center",
                width: 302,
                height: 225,
                margin: "auto",
              }}
            >
              {item.name}
            </h4>
          )}
        </div>
        <div className="oreuibutton">
          <div className="oreuibuttoninner">
            <div className="oreuibuttontext cosmetics">
              <div
                className="oreuitextblock cosmetics"
                style={{ color: nameColor }}
              >
                {item.name || "Unknown Item"}
              </div>
              {item.rarity && (
                <div className={`text-block-dark`}>
                  <div
                    className={`unicode-sprite ${rarityImages[item.rarity]}`}
                  ></div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </a>
  );
}
